export const StartupStages = {
    Seed: "Seed stage",
    Early: "Early stage",
    Later:"Later stage"
  };